/**
 * Initial Goals tab — goal types from API, then dashed placeholder until a type is chosen.
 */
import { useCallback } from 'react'
import SohoLoader from '../../common/SohoLoader/SohoLoader'
import './GoalsSummaryHeader.css'

function GoalsZeroState({
  onPresetSelect,
  selectedGoalsPreset,
  presets = [],
  typesLoading = false,
  hidePlaceholder = false,
}) {
  const handlePresetClick = useCallback(
    (presetId) => {
      if (typeof onPresetSelect === 'function') {
        onPresetSelect(presetId)
      }
    },
    [onPresetSelect],
  )

  return (
    <div className="goalsInitialCard">
      <section
        className="goals-zero-state"
        role="region"
        aria-labelledby="goals-zero-heading"
      >
        <h3 id="goals-zero-heading" className="goals-zero-heading">
          No goals active yet
        </h3>
        <p className="goals-zero-subtext">
          Set measurable targets for visibility, engagement, and growth to track performance over time.
        </p>

        <div className="goal-presets" role="group" aria-label="Goal strategy presets">
          {typesLoading && presets.length === 0 ? (
            <div className="goalsZeroStateLoader" role="status" aria-live="polite">
              <SohoLoader size="sm" message="Loading goal strategies…" />
            </div>
          ) : (
            <>
              {presets.map((preset) => (
                <button
                  key={preset.id}
                  type="button"
                  role="button"
                  aria-pressed={selectedGoalsPreset === preset.id}
                  aria-label={`Select ${preset.name} strategy`}
                  className={`goal-preset-chip ${selectedGoalsPreset === preset.id ? 'goal-preset-chip--pressed' : ''}`}
                  onClick={() => handlePresetClick(preset.id)}
                >
                  {preset.name}
                </button>
              ))}
            </>
          )}
        </div>

        <p className="goal-presets-helper muted">
          Tip: pick a strategy to pre-fill the most relevant metrics.
        </p>
      </section>

      {!hidePlaceholder && (
        <div className="goalsEmptyState goalsEmptyState--initial">
          <div className="goalsEmptyTitle">Pick goals to see progress</div>
          <div className="goalsEmptyText">
            Choose a goal type to get started. We will guide you through picking metrics and saving.
          </div>
        </div>
      )}
    </div>
  )
}

export default GoalsZeroState
